import { get, map, keyBy } from "lodash"
import { createSelector } from "reselect"
import { getUserDatasets, getIsOpPro } from "modules/account-root/selectors"
import { getRole } from "helpers/permissions/roles"
import { computeDatasetEntitlementsTabs } from "helpers/permissions/tabs"
import { getPath, getRoute } from "selectors/urls"

const EMPTY_ARRAY = []
const getAdminDatasets = (state) => get(state, "global.data.adminDatasets.data")
const getRawEntitlements = state => get(state, "global.data.memberDatasetEntitlements.data")

export const getDatasets = createSelector(
  [getAdminDatasets, getRole],
  (adminDatasets, role) => role === "admin" ? adminDatasets : EMPTY_ARRAY,
)

export const getEntitlements = createSelector(
  [getRawEntitlements, getUserDatasets],
  (entitlements, datasets) => {
    const datasetsById = keyBy(datasets, "id")
    return map(entitlements, ({ dataset, direct, teams }) => ({
      ...dataset,
      description: get(datasetsById, [dataset.id, "description"]),
      direct,
      teams,
    }))
  },
)

export const getTabs = createSelector(
  [getRoute, getPath, getIsOpPro],
  computeDatasetEntitlementsTabs,
)
